export default __webpack_public_path__ + "static/media/ReportingConnecsIcon.6427f623.svg";